import React, { useState } from "react";
import * as S from "./Journey.style";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { mockTimelineSteps, mockBlocks } from "./mockJourneyData";

import JourneyHeader from "./components/journeyHeader/JourneyHeader";
import JourneyTimeline from "./components/journeyTimeline/JourneyTimeline";
import JourneyPhaseBlock from "./components/journeyPhaseBlock/JourneyPhaseBlock";

function Journey() {
  const { patientId } = useParams();
  const { t } = useTranslation("global");
  // En un caso real buscarías al paciente por ID. Aquí usamos datos mock.
  const patientMock = {
    id: patientId,
    name: "Jullietta Lopez",
    condition: "Cancer de mama",
    img: "https://i.pravatar.cc/150?img=5"
  };

  return (
    <S.Journey>
      <JourneyHeader patient={patientMock} />

      <div className="journey-content">
        <JourneyTimeline steps={mockTimelineSteps} />
        
        <div className="blocks-container">
          <div className="toggle-banner">
            <div className="toggle-text">
              <i className="icon zaia-icono-ojo-n-cerrado zaia-icono-visibility" /> Ocultar hitos no disponibles aun <strong>1</strong>
            </div>
            <div className="dashed-line" />
          </div>

          {mockBlocks.map((block) => (
            <React.Fragment key={block.id}>
              <JourneyPhaseBlock block={block} />
              
              {/* Optional toggles can be added between specific blocks manually for UI demonstration */}
              {block.id === "block-inicio" && (
                <div className="toggle-banner">
                  <div className="toggle-text">
                    <i className="icon zaia-icono-ojo-n-cerrado" /> Oculatar hitos completados <strong>2</strong>
                  </div>
                  <div className="dashed-line" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </S.Journey>
  );
}
export default Journey;